(ns bec-cljs-common.light-control
  (:require [taoensso.timbre :as log]
            [re-frame.core :as rf]
            [ajax.core :as ajax :refer [json-request-format json-response-format]]
            [clojure.core.async :as async]
            [bec-cljs-common.re-frame :as bcc.rf]
            [bec-cljs-common.config :as config]
            [bec-cljs-common.worker :as bcc.worker]))


(defn path [& args]
  (apply conj [:light-control] args))


(defn path-config [& args]
  (apply conj [:config :light-control] args))


(defn get-preset "Gets the current preset data for `preset-name`."
  [db preset-name]
  (when-not preset-name
    (log/warn ::preset "no preset-name given?"))
  (or (get-in db (path :presets preset-name)) ;; User override.
      (get-in db (path-config :presets preset-name)))) ;; Defaults from config.


(rf/reg-sub ::preset
  (fn [db preset-name]
    (get-preset db preset-name)))


(rf/reg-sub ::current-preset
  (fn [db _]
    (get-in db (path :current-preset))))


(rf/reg-sub ::current-rgbw
  (fn [db _]
    (get-in db (path :current-rgbw))))


(rf/reg-sub ::presets
  (fn [db _]
    (merge (get-in db (path-config :presets)) ;; Defaults from config.
           (get-in db (path :presets))))) ;; User overrides.


;; (rf/reg-event-fx ::set-rgbw
;;   (fn [{:keys [db]} [_ light-value]]
;;     {:db (assoc-in db [:loading :light-control-set-rgbw] true)
;;      :fx [[:http-xhrio {:method :put
;;                         :uri (str config/app-server-url "/light-control/set-rgbw")
;;                         :params light-value ;; [123 123 123 123]
;;                         :format (json-request-format)
;;                         :response-format (json-response-format {:keywords? true})
;;                         :timeout 15000
;;                         :on-success [:request-success :light-control-set-rgbw]
;;                         :on-failure [:request-failure :light-control-set-rgbw]}]]}))


(rf/reg-event-fx ::set-preset
  (fn [{:keys [db]} [_ preset]]
    {:db db
     :fx [[:dispatch [::bcc.rf/xhrio {:method :put
                                      :uri (str config/app-server-url "/light-control/set-preset")
                                      :params (first preset) ;; :playing
                                      :format (json-request-format)
                                      :response-format (json-response-format {:keywords? true})}]]]}))


(let [ch (async/chan (async/sliding-buffer 1))]
  (bcc.worker/go-task-handler! ch)
  (rf/reg-event-fx ::set-preset-rgbw ;;:light-control-preset-set-rgbw
    (fn [{:keys [db]} [_ light-value]]
      (async/put! ch (bcc.worker/with-result-ch
                       (fn [result-ch]
                         (rf/dispatch [::bcc.rf/xhrio {:method :put, :uri (str config/app-server-url "/light-control/preset-set-rgbw")
                                                       :event-key ::set-preset-rgbw
                                                       :params light-value
                                                       :format (json-request-format)
                                                       :response-format (json-response-format {:keywords? true})
                                                       :result-ch result-ch}]))))
      {:db db})))
